module.exports = __webpack_public_path__ + "img/potrait-service.5e8d59db.png";